__turbopack_context__.v({
  "className": "raleway_9f0a1927-module__PnixbW__className",
  "variable": "raleway_9f0a1927-module__PnixbW__variable",
});
